var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { compileImageTransforms } from './transforms/imageTransforms';
var cloudinary = function (_a) {
    var cloudName = _a.cloudName, _b = _a.assetType, assetTypeDefault = _b === void 0 ? 'image' : _b, _c = _a.deliveryType, deliveryTypeDefault = _c === void 0 ? 'upload' : _c, _d = _a.secure, secure = _d === void 0 ? true : _d, _e = _a.cdnSubdomain, cdnSubdomain = _e === void 0 ? 'res' : _e, _f = _a.cname, cname = _f === void 0 ? cdnSubdomain + ".cloudinary.com" : _f, defaultTransform = _a.imageTransformDefaults;
    if (process.env.NODE_ENV !== 'production') {
        if (!cloudName) {
            throw new Error('Cloudinary configuration requires a `cloudName` option.');
        }
    }
    var baseUrl = "http" + (secure ? 's' : '') + "://" + cname + "/" + cloudName + "/";
    return function (publicId, options) {
        if (Array.isArray(options)) {
            options = { transformations: options };
        }
        var _a = options !== null && options !== void 0 ? options : {}, _b = _a.deliveryType, deliveryType = _b === void 0 ? deliveryTypeDefault : _b, _c = _a.assetType, assetType = _c === void 0 ? assetTypeDefault : _c, _d = _a.version, version = _d === void 0 ? '' : _d, transformations = _a.transformations, rest = __rest(_a, ["deliveryType", "assetType", "version", "transformations"]);
        if (version) {
            version = "/" + (version.toString().startsWith('v') ? version : 'v' + version);
        }
        var transformation = assetType === 'image' ? compileImageTransforms(transformations !== null && transformations !== void 0 ? transformations : rest, defaultTransform) : '';
        return "" + baseUrl + assetType + "/" + deliveryType + transformation + version + "/" + publicId;
    };
};
export default cloudinary;
